<template>
    <div class="questionBank">
        <div class="componentTop">
            <div class="componentText">课程题库</div>
        </div>
        <div class="formNav">
            <a-form-model  layout="inline" class="formModel"  :model="form">
                <a-form-model-item label="题干关键字:" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-input v-model="form.qastoreContent" style="width: 180px" />
                </a-form-model-item>
                <a-form-model-item label="题目标签:" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-input v-model="form.keyword" style="width: 180px" />
                </a-form-model-item>
                <a-form-model-item label="题型">
                    <a-select v-model="form.qastoreType" placeholder="请选择" style="width: 100px">
                        <a-select-option value="">
                            请选择
                        </a-select-option>
                        <a-select-option value="radio">
                           单选
                        </a-select-option>
                        <a-select-option value="checkbox">
                            多选
                        </a-select-option>
                        <a-select-option value="whether">
                            是非题
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item >
                    <a-button type="primary" @click="search">
                        搜索
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="table">
            <a-card :bordered="false">
                <div class="table-operations">
                    <a-button @click="addSingleQuestion">
                        新增单选题
                    </a-button>
                    <a-button @click="addMultiQuestion">
                        新增多选题
                    </a-button>
                    <a-button @click="addJudgementQuestion">
                        新增是非题
                    </a-button>
                    <a-button @click="multiImportQuestion">
                        excel批量导入
                    </a-button>
                    <a-button @click="multiExportQuestion">
                        批量导出题目
                    </a-button>
                    <a-button @click="deleteQuestion">
                        删除
                    </a-button>
                </div>
                <div>
                    <a-modal
                            title="导入题目"
                            :width="1000"
                            :visible="modalVisible"
                            :confirm-loading="confirmLoading"
                            @ok="handleModalOk"
                            @cancel="handleModalCancel"
                    >
                        <a-form-model>
                            <p>说明：可通过excel表将题目信息批量导入到题库中，模板可通过这里
                                <a :href="downUrl">下载excel模板</a>
                                获得。
                            </p>
                        </a-form-model>
                        <a-upload
                                name="file"
                                :multiple="false"
                                :action="imageUpload"
                                :fileList="fileList"
                                :data="importData"
                                :headers="headers"
                                :remove="handleRemove"
                                :beforeUpload="beforeUpload"
                                accept=".xls,.xlsx"
                                @change="handleChange"
                        >
                            <a-button> <a-icon type="upload" />点击上传</a-button>
                        </a-upload>
                        <div style="text-align: center;margin-top: 30px">
                            <a-button @click="lookSucess" style="margin-right: 10px">
                                查看成功记录
                            </a-button>
                            <a-button @click="lookFail">
                                查看失败记录
                            </a-button>
                        </div>
                        <br>
                        <a-table :columns="columns1" :dataSource="fileListsourceData">
                            <span slot="noticeType" slot-scope="noticeType">
                                    {{noticeType=='radio'?'单选题':''}}
                                    {{noticeType=='checkbox'?'多选题':''}}
                                    {{noticeType=='whether'?'是非题':''}}
                                </span>
                            <span slot="customTitle" style="display: flex;align-items: center">
                                <span style="margin-right: 5px">操作</span>
                            </span>
                            <span slot="action" slot-scope="action,rowKey">
                                <a @click="editQuestion(rowKey)">编辑</a>
                            </span>
                        </a-table>
                    </a-modal>
                </div>
                <a-table :columns="columns" :dataSource="sourceData" :loading="loading" @change="handleQuestionTableChange"
                         :pagination="pagination"
                         :row-selection="{onChange: onSelectChange }"
                         :rowKey="(data,index)=>index">
                      <span slot="noticeType" slot-scope="noticeType">
                            {{noticeType=='radio'?'单选题':''}}
                            {{noticeType=='checkbox'?'多选题':''}}
                            {{noticeType=='whether'?'是非题':''}}
                        </span>
                    <span slot="customTitle" style="display: flex;align-items: center">
                        <span style="margin-right: 5px">操作</span>
                     </span>
                    <span slot="action" slot-scope="action,rowKey">
                        <a @click="editQuestion(rowKey)">编辑</a>
                    </span>
                </a-table>
                <a-drawer
                        :title="modelTitle"
                        :width="720"
                        @close="onClose"
                        :visible="visible"
                        :bodyStyle="{ paddingBottom: '80px' }"
                >
                    <a-form-model
                            :layout="drawFormLayout"
                            :model="drawForm"
                            ref="ruleForm"
                            :rules="rules"
                    >
                        <a-form-model-item label="题干:" prop="qastoreContent">
                            <a-input v-model="drawForm.qastoreContent" type="textarea"
                                     :max-length="200"
                                     :auto-size="{ minRows: 3, maxRows: 6 }"
                            />
                        </a-form-model-item>
                        <a-form-model-item label="题目标签:" prop="keyword">
                            <a-input
                                    v-model="drawForm.keyword"
                                    :max-length="100"
                            />
                            <p style="line-height: 20px;color: #999999;font-size: 12px"
                            >注：题目标签用于方便抽题，查询题目等。多个标签可以用中文或英文的‘，’分隔。例如：语文,文言文撰写,第一套题
                            </p>
                        </a-form-model-item>
                        <a-form-model-item label="题目解释:" prop="ansAnalyze">
                            <a-input v-model="drawForm.ansAnalyze" type="textarea"
                                     :max-length="200"
                                     :auto-size="{ minRows: 3, maxRows: 6 }"
                            />
                        </a-form-model-item>
                        <div  v-if="formType==='radio'|| formType==='checkbox'">
                            <!--单选或者多选-->
                            <a-form-model-item>
                                <label class="ant-form-item-required" style="color: rgba(0, 0, 0, 0.85)">题目选项</label>
                            </a-form-model-item>
                            <a-form-model-item
                                    v-for="(domain, index) in drawForm.qastoreOptions"
                                    :key="domain.key"
                                    v-bind="formItemLayout"
                                    :prop="'qastoreOptions.' + index + '.value'"
                                    :rules="{
                                            required: true,
                                            message: '选项内容不能为空',
                                            trigger: 'blur',
                                             }"
                            >
                                <div class="optionItem" style="display: flex;align-items: center;justify-content: space-between">
                                    <p style="width:50px ">选项{{index+1}}</p>
                                    <a-input v-model="domain.value" type="textarea"
                                             :max-length="200"
                                             :auto-size="{ minRows: 5, maxRows: 5 }"
                                             style="width: 350px"
                                    />
                                    <div v-if="formType==='radio'">
                                        <input :type="formType==='radio'?'radio':'checkbox'" :value="domain.key" v-model="radioFlag"  name="radio" @change="onChangeRadio(domain)" />该选项为正确答案
                                    </div>
                                    <div v-if="formType!=='radio'">
                                        <input :type="formType==='radio'?'radio':'checkbox'" :value="domain.key" v-model="domain.radioSelect"  name="radio" @change="onChangeRadio(domain)" />该选项为正确答案
                                    </div>
                                    <a-icon
                                            v-if="drawForm.qastoreOptions.length > 1"
                                            class="dynamic-delete-button"
                                            type="minus-circle-o"
                                            :disabled="drawForm.qastoreOptions.length === 1"
                                            @click="removeDomain(domain)"
                                    />
                                </div>

                            </a-form-model-item>
                            <a-form-model-item >
                                <a-button type="primary" style="width: 30%" @click="addDomain">
                                    <a-icon type="plus" />添加选项
                                </a-button>
                            </a-form-model-item>
                        </div>
                        <div v-if="formType==='whether'">
                                <!--判断题-->
                            <a-form-model-item label="正确答案:" prop="answer">
                                <a-radio-group v-model="drawForm.answer">
                                    <a-radio value="Y">
                                        是
                                    </a-radio>
                                    <a-radio value="N">
                                        否
                                    </a-radio>
                                </a-radio-group>
                            </a-form-model-item>
                        </div>
                      </a-form-model>

                      <div
                            :style="{
                      position: 'absolute',
                      right: 0,
                      bottom: 0,
                      width: '100%',
                      borderTop: '1px solid #e9e9e9',
                      padding: '10px 16px',
                      background: '#fff',
                      textAlign: 'right',
                      zIndex: 1,
                     }"
                    >
                        <a-button :style="{ marginRight: '8px' }" @click="onClose">
                            取消
                        </a-button>
                        <a-button @click="handleSubmit()" type="primary" :disabled="buttonDisable"
                        >确定</a-button>
                    </div>
                </a-drawer>
            </a-card>
        </div>
    </div>
</template>

<script>
    import {getAppId} from '../../../core/appUtils';
    import {console} from '../../../core/util/helper';

    const columns = [
        {
            title: '题干',
            dataIndex: 'qastoreContent',
            width: '45%',
            ellipsis: true
        },
        {
            title: '题目标签',
            dataIndex: 'keyword',
            width: '20%',
            ellipsis: true
        },
        {
            title: '题型',
            dataIndex: 'qastoreType',
            width: '12%',
            scopedSlots: { customRender: 'noticeType' }
        },
        {
            slots: { title: 'customTitle' },
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            width: '100px'
        }
    ];
    const columns1 = [
        {
            title: '题干',
            dataIndex: 'qastoreContent',
            width: '45%',
            ellipsis: true
        },
        {
            title: '题型',
            dataIndex: 'qastoreType',
            width: '15%',
            scopedSlots: { customRender: 'noticeType' }
        },
        {
            title: '失败原因',
            dataIndex: 'message',
            width: '40%',
            ellipsis: true
        }
    ];

    export default {
        name: 'courseQuestionBank',
        data(){
            return {
                //上传
                headers: {
                    'Authorization':'Bearer ' + this.appUtils.getToken()
                },
                importData:{
                    researchId: this.appUtils.getResearchId()
                },
                downloadSuccessUrl:'',
                downloadFailUrl:'',
                downUrl:this.apis.courseQuestionBank.templateUrl,
                fileList: [],
                imageUpload:'',
                //模态框
                modalVisible: false,
                confirmLoading: false,
                //test
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 20 }
                    }
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        xs: { span: 24, offset: 0 },
                        sm: { span: 20, offset: 4 }
                    }
                },
                //搜索栏
                labelCol: { span: 8 },
                wrapperCol: { span: 12 },
                form: {
                    keyword: '',
                    qastoreType: undefined,
                    qastoreContent:''
                },
                //表单展示
                loading: false,
                selectedRowKeys:[],
                sourceData:[],
                fileListsourceData:[],
                columns,
                columns1,
                pagination:{
                    currentPage:1,
                    pageSize:10,
                    total:10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    //  showTotal: total => `共有 ${total} 条`, // 显示总数
                    pageSizeOptions: ['10', '20', '30', '40', '50']
                },
                //抽屉
                modelTitle:'',
                visible: false,
                buttonDisable: false,
                drawFormLayout:'horizontal',
                //抽屉表单
                radioSelect:true,
                radioFlag:false,
                qastoreId:'',//题目id 只有编辑才有
                isEdit:false,//默认类型是新增
                formType:'',//三种不同类型题目 radio=单选,checkbox=多选,whether=判断题
                drawForm: {
                    updatedBy:'更吓人',
                    drawForm:'创建人',
                    difficult:'difficult',
                    itemCount:2,
                    qastoreOptions: [
                        {
                            value:'',
                            key: Date.now()
                        },
                        {
                            value:'',
                            key: Date.now()+Date.now()
                        }
                    ],
                    qastoreContent: '',//题干
                    keyword: '',//标签
                    ansAnalyze:'',//解释,
                    answer:''
                },
                rules: {
                    qastoreContent: [
                        { required: true, message: '题干必填!', trigger: 'blur' }
                    ],
                    keyword:[
                        { max: 100, message: '超出最大字符长度100', trigger: 'blur' }
                    ],
                    ansAnalyze:[
                       { max: 200, message: '超出最大字符长度200', trigger: 'blur' }
                    ],
                    answer: [
                        { required: true, message: '请设置答案', trigger: 'change' }
                    ]
                }
            };
        },
        mounted(){
            this.imageUpload=this.apis.courseQuestionBank.importExcel;
            this.getQuestionList();
        },
        methods:{
            //批量导入
            lookSucess(){
                if (this.downloadSuccessUrl===''){
                    this.$message.error('请先上传模板!');
                } else {
                    window.open(this.apis.courseQuestionBank.lookRecord + this.downloadSuccessUrl);
                }
            },
            lookFail(){
                if (this.downloadFailUrl===''){
                    this.$message.error('请先上传模板!');
                } else {
                    window.open(this.apis.courseQuestionBank.lookRecord + this.downloadFailUrl);
                }
            },
            //上传
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            beforeUpload(file,fileList){
                console.log(file);
                if (file.size/1048576>100){
                    this.$message.error('超出附件大小!');
                    return false;
                }
                if (file.type.indexOf('xls') > 0||file.type.indexOf('vnd.ms-excel')|| file.type.indexOf('xlsx') > 0 ||file.type===''){
                    // console.log("执行上传");
                } else {
                    fileList=[];
                    this.$nextTick(function () {
                        this.fileList = [];
                    });
                    this.$message.error('上传文件不符');
                    return false;
                }
                this.fileList = [...this.fileList, file];
                if ( this.fileList.length>1){
                    this.fileList.splice(1,1);
                }
            },
            handleChange(res) {
                console.log(res);
                if (res.file){
                    let fileList = [...res.fileList];
                    fileList = fileList.slice(-1);
                    this.fileList = fileList;
                    if (res.file.status==='done'&&res.file.response.status===0){
                        this.$message.success(`成功导入${res.file.response.data.count}条数据`);
                         console.log(this.fileList);
                        this.downloadFailUrl=res.file.response.data.downloadFailUrl;
                        this.downloadSuccessUrl=res.file.response.data.downloadSuccessUrl;
                    } else if (res.file.status==='done'&&res.file.response.status!==0){
                        this.$message.error(`${res.file.response.message}`);
                    } else if (res.file.status==='error'){
                        this.$message.error(`${res.file.name} file upload failed.`);
                    }

                    this.fileListsourceData = res.file.response.data.errorList;
                }
            },
            //模态框
            handleModalOk(e) {
                this.confirmLoading = true;
                setTimeout(() => {
                    this.modalVisible = false;
                    this.confirmLoading = false;
                }, 2000);
                this.getQuestionList();
            },
            handleModalCancel(e) {
                console.log('Clicked cancel button');
                this.fileList=[];
                this.downloadSuccessUrl='';
                this.downloadFailUrl='';
                this.modalVisible = false;
            },
            //抽屉表单操作
            onChangeRadio(item){
                if (this.formType==='radio'){
                    this.drawForm.qastoreOptions.forEach((key)=>key.radioSelect=false);
                    item.radioSelect=true;
                } else {
                    if (item.isAnswer==='Y'){
                        item.radioSelect=false;
                        item.isAnswer='N';
                    } else if (item.isAnswer==='N'){
                        item.isAnswer='Y';
                        item.radioSelect=true;
                    }
                    console.log(this.drawForm);
                }
            },
            removeDomain(item) {
                let index = this.drawForm.qastoreOptions.indexOf(item);
                if (index !== -1) {
                    this.drawForm.qastoreOptions.splice(index, 1);
                }
            },
            addDomain() {
                this.drawForm.qastoreOptions.push({
                    value: '',
                    key: Date.now()
                });
            },
            //抽屉
            handleSubmit(){
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                          if (this.formType!=='whether'){
                              if (this.drawForm.qastoreOptions.find(item=>item.radioSelect===true)){
                                  let temp={
                                      ...this.drawForm
                                  };
                                  //如果是单选题
                                  if (this.formType==='radio'){
                                      temp.qastoreType='radio';
                                  } else {
                                      temp.qastoreType='checkbox';
                                  }
                                  for (let i=0;i<temp.qastoreOptions.length;i++){
                                      temp.qastoreOptions[i].optionContent=temp.qastoreOptions[i].value;
                                      if (temp.qastoreOptions[i].radioSelect===true){
                                          delete temp.qastoreOptions[i].radioSelect;
                                          temp.qastoreOptions[i].isAnswer='Y';
                                      } else {
                                          delete temp.qastoreOptions[i].radioSelect;
                                          temp.qastoreOptions[i].isAnswer='N';
                                      }
                                      delete temp.qastoreOptions[i].key;
                                      delete temp.qastoreOptions[i].value;
                                  }
                                  delete temp.answer;
                                  temp.itemCount=temp.qastoreOptions.length;
                                  if (this.isEdit){
                                      //编辑
                                      temp.qastoreId=this.qastoreId;
                                      console.log(temp);

                                  } else {
                                      temp.researchId=this.importData.researchId;
                                      console.log(temp);
                                      //新增
                                  }
                                   this.postQuestion(temp);
                              } else {
                                  this.$message.error('至少设置一项正确答案!');
                                  return false;
                              }
                          } else {
                              let temp={
                                  ...this.drawForm,
                                  qastoreType:'whether'
                              };
                              if (temp.answer==='Y'){
                                  temp.qastoreOptions[0].optionContent='是';
                                  temp.qastoreOptions[0].isAnswer='Y';

                                  temp.qastoreOptions[1].optionContent='否';
                                  temp.qastoreOptions[1].isAnswer='N';
                                  delete temp.qastoreOptions[0].key;
                                  delete temp.qastoreOptions[0].value;

                                  delete temp.qastoreOptions[1].key;
                                  delete temp.qastoreOptions[1].value;
                              } else {
                                  temp.qastoreOptions[0].optionContent='否';
                                  temp.qastoreOptions[0].isAnswer='Y';

                                  temp.qastoreOptions[1].optionContent='是';
                                  temp.qastoreOptions[1].isAnswer='N';

                                  delete temp.qastoreOptions[0].key;
                                  delete temp.qastoreOptions[0].value;
                                  delete temp.qastoreOptions[1].key;
                                  delete temp.qastoreOptions[1].value;
                              }
                              delete temp.answer;
                              temp.itemCount=temp.qastoreOptions.length;
                              if (this.isEdit){
                                  //编辑
                                  temp.qastoreId=this.qastoreId;
                                  console.log(temp);
                              } else {
                                  temp.researchId=this.importData.researchId;
                                  console.log(temp);
                                  //新增
                              }
                              this.postQuestion(temp);
                          }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            onClose() {
                this.visible = false;
                this.resetForm();
                this.drawForm.qastoreOptions=[
                    {
                        value:'',
                        key: Date.now()
                    },
                    {
                        value:'',
                        key: Date.now()+Date.now()
                    }
                ];
            },
            //重置表单
            resetForm() {
                this.$refs.ruleForm.resetFields();
            },
            //工具栏操作
            addSingleQuestion(){
                this.isEdit=false;
                this.visible = true;
                this.formType='radio';
                this.modelTitle='新增单选题';
            },
            addMultiQuestion(){
                this.isEdit=false;
                this.visible = true;
                this.formType='checkbox';
                this.modelTitle='新增多选题';
            },
            multiExportQuestion(){
                // keyWord:this.form.keyword,
                // qastoreType:this.form.qastoreType,
                // qastoreContent:this.form.qastoreContent
                // deleteQastore
                // // https://api.dev.gdteacher.com/studyService/qastore/qastore-qastoreinfo/excel-export?researchId=9788d64271a642069433e7c70dc7c946&keyWord=11111&qastoreType=checkbox&qastoreContent=1111
                var url = this.apis.courseQuestionBank.qastoreExport+'?researchId='+this.appUtils.getResearchId();
                if (this.form.keyword){
                    url = url + '&keyWord=' + this.form.keyword;
                }
                if (this.form.qastoreType){
                    url = url + '&qastoreType=' + this.form.qastoreType;
                }
                if (this.form.qastoreContent){
                    url = url + '&qastoreContent=' + this.form.qastoreContent;
                }

                window.open(this.appUtils.getSignWithUrl(url), '_blank');
            },
            multiImportQuestion(){
                this.modalVisible=true;
                console.log('批量导入');
            },
            deleteQuestion(){
                if (this.selectedRowKeys.length===0){
                    this.$message.error('至少选择一条需要被删除的数据!');
                    return false;
                }
                let tempArry=[];
                let canDeleted=[];
                this.selectedRowKeys.forEach((item)=>{
                    tempArry.push(item.qastoreId);
                    canDeleted.push(item.canDeleted);
                });
             let flag= canDeleted.every(item=>{
                    return item!=='N';
                });
                if (flag){
                    console.log(tempArry);
                    this.deleteQastore(tempArry);
                } else {
                    this.$message.error('数据中包含弹题题目,不能被删除!');
                }
            },
            addJudgementQuestion(){
                this.isEdit=false;
                this.visible = true;
                this.formType='whether';
                this.modelTitle='新增是非题';
            },
            //table操作
            onSelectChange(selectedRowKeys, selectedRows){
                this.selectedRowKeys=selectedRows;
            },
            handleQuestionTableChange(pagination){
                this.pagination.pageSize=pagination.pageSize;
                this.pagination.currentPage=pagination.current;
                this.getQuestionList();
            },
            fileListhandleQuestionTableChange(pagination){
                this.pagination.pageSize=pagination.pageSize;
                this.pagination.currentPage=pagination.current;
                this.getQuestionList();
            },
            search() {
                this.getQuestionList();
            },
            editQuestion(v){
                if (v.qastoreType==='whether'){
                    this.formType='whether';
                    this.modelTitle='编辑是非题';
                    this.getQuestionDetail(v.qastoreId,'whether');

                } else if (v.qastoreType==='radio'){
                    this.formType='radio';
                    this.modelTitle='编辑单选题';
                    this.getQuestionDetail(v.qastoreId,'radio');
                } else {
                    this.formType='checkbox';
                    this.modelTitle='编辑多选题';
                    this.getQuestionDetail(v.qastoreId,'checkbox');
                }
                this.visible = true;
                this.isEdit=true;
            },
            deleteQastore(params){
                this.http.post(this.apis.courseQuestionBank.deleteQastore,params).then(res => {
                    if (res.status === 0){
                        this.$message.success('删除成功');
                        this.getQuestionList();
                    }
                }).catch(err => {
                    this.$message.error('请求失败');
                });
            },
            getQuestionDetail(questionId,type){
                this.http.get(this.apis.courseQuestionBank.getQuestionDetail+questionId).then(res => {
                    if (res.status === 0){
                        console.log(res);
                        this.qastoreId=res.data.qastoreId;
                        this.drawForm.qastoreContent=res.data.qastoreContent;
                        this.drawForm.keyword=res.data.keyword;
                        this.drawForm.ansAnalyze=res.data.ansAnalyze;
                        if (type==='whether'){
                            for (let i=0;i<res.data.options.length;i++){
                                 if (res.data.options[i].isAnswer==='Y'){
                                     if (res.data.options[i].optionContent==='否' || res.data.options[i].optionContent==='错误'){
                                         this.drawForm.answer='N';
                                     } else {
                                         this.drawForm.answer='Y';
                                     }
                                 }
                            }
                            // this.drawForm.answer=res.data.options[0].isAnswer;
                        } else if (type==='radio'){
                            for (let i=0;i<res.data.options.length;i++){
                                res.data.options[i].value=res.data.options[i].optionContent;
                                res.data.options[i].key=res.data.options[i].optionId;
                                if (res.data.options[i].isAnswer==='N'){
                                    res.data.options[i].radioSelect=false;
                                } else {
                                    res.data.options[i].radioSelect=true;
                                    this.radioFlag=res.data.options[i].key;
                                }
                            }
                            this.drawForm.qastoreOptions=res.data.options;
                        } else {
                            for (let i=0;i<res.data.options.length;i++){
                                res.data.options[i].value=res.data.options[i].optionContent;
                                res.data.options[i].key=res.data.options[i].optionId;
                                if (res.data.options[i].isAnswer==='N'){
                                    res.data.options[i].radioSelect=false;
                                } else {
                                    res.data.options[i].radioSelect=true;
                                    this.radioFlag=res.data.options[i].key;
                                }
                            }
                            this.drawForm.qastoreOptions=res.data.options;
                            console.log(this.drawForm);
                        }
                    }
                }).catch(err => {
                    this.$message.error('请求失败');
                });
            },
            getQuestionList(){
                let params={
                    researchId:this.importData.researchId,
                    keyWord:this.form.keyword,
                    qastoreType:this.form.qastoreType,
                    qastoreContent:this.form.qastoreContent
                };
                this.loading = true;
                this.http.get(this.apis.courseQuestionBank.getQuestionList+'?currentPage='+this.pagination.currentPage+'&pageSize='+this.pagination.pageSize,params).then(res => {
                    if (res.status === 0){
                        this.sourceData=res.data;
                        this.loading = false;
                        this.pagination.total=res.pageInfo.totalCount;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.$message.error('请求失败');
                });
            },
            postQuestion(params){
                this.http.post(this.apis.courseQuestionBank.postQastore,params).then(res => {
                    if (res.status === 0){
                        this.$message.success('新增成功');
                        this.onClose();
                        this.visible=false;
                        this.getQuestionList();
                    }
                }).catch(err => {
                    this.$message.error('请求失败');
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .questionBank{
        .componentTop{
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            padding: 25px 40px;
            .componentText{
                font-size: 30px;
                color: #333333;
            }
        }
        .formNav{
            .formModel{
                display: flex;
                justify-content: space-around;
            }
        }
        .table{
            .table-operations{
                display: flex;
                justify-content: flex-end;
                margin: 5px;
                padding: 5px;
                button{
                    margin-left: 10px;
                }
            }
        }

    }
</style>
